<template>
    <!-- ========== Left Sidebar Start ========== -->
    <div class="left-side-menu" id="left-side-bar">
        <div class="slimscroll-menu" id="left-side-menu-container" ref="menu">
            <!-- LOGO -->
            <router-link to="/" class="logo text-center">
                <span class="logo-lg">
                    <img src="@/client/img/sp_logo.png" alt="seekpeek" id="side-main-logo" />
                </span>
            </router-link>
            <!--- Sidemenu -->
            <ul
                class="metismenu side-nav"
                id="left-bar-menu"
                ref="side-nav"
                v-if="currentWebsiteId"
            >
                <li class="side-nav-title side-nav-item">Contents</li>

                <router-link
                    v-if="false"
                    to="/"
                    class="side-nav-item"
                    tag="li"
                    active-class="mm-active"
                    exact
                >
                    <a class="side-nav-link">
                        <i class="dripicons-meter"></i>
                        <span>Dashboard</span>
                    </a>
                </router-link>

                <template v-if="false">
                    <router-link
                        :to="{ name: 'website-settings', params  }"
                        class="side-nav-item"
                        tag="li"
                        active-class="mm-active"
                        exact
                    >
                        <a class="side-nav-link">
                            <i class="dripicons-gear"></i>
                            <span>Settings</span>
                        </a>
                    </router-link>

                    <router-link
                        :to="{ name: 'website-products', params }"
                        class="side-nav-item"
                        tag="li"
                        active-class="mm-active"
                    >
                        <a class="side-nav-link">
                            <i class="dripicons-cart"></i>
                            <span>Products</span>
                        </a>
                    </router-link>

                    <router-link
                        :to="{ name: 'website-product-requests', params }"
                        class="side-nav-item"
                        tag="li"
                        active-class="mm-active"
                    >
                        <a @click.prevent="doNothing" class="side-nav-link">
                            <i class="dripicons-message"></i>
                            <span>Product Requests</span>
                        </a>
                    </router-link>
                </template>

                <router-link
                    :to="{ name: 'website-settings', params }"
                    v-slot="{ href, navigate, isExactActive }"
                >
                    <li :class="{'mm-active': isExactActive }">
                        <a :href="href" @click="navigate" class="side-nav-link">
                            <i class="dripicons-gear"></i>
                            <span>Settings</span>
                        </a>
                    </li>
                </router-link>

                <router-link
                    :to="{ name: 'website-products', params }"
                    v-slot="{ href, navigate, isActive }"
                >
                    <li :class="{'mm-active': isActive }">
                        <a :href="href" @click="navigate" class="side-nav-link">
                            <i class="dripicons-cart"></i>
                            <span>Products</span>
                        </a>
                    </li>
                </router-link>

                <router-link
                    :to="{ name: 'website-product-requests', params }"
                    v-slot="{ href, navigate, isActive }"
                >
                    <li :class="{'mm-active': isActive}">
                        <a :href="href" @click="navigate" class="side-nav-link">
                            <i class="dripicons-message"></i>
                            <span>Product Requests</span>
                        </a>
                    </li>
                </router-link>
            </ul>
            <!-- End Sidebar -->

            <div class="clearfix"></div>
        </div>
        <!-- Sidebar -left -->
    </div>
    <!-- Left Sidebar End -->
</template>

<script>
import { mapState } from "vuex";

export default {
    methods: {
        init() {
            // $(this.$refs["side-nav"]).metisMenu();

            // console.log(this.$refs.menu);
            this.$nextTick(() => {
                $(this.$refs.menu).slimscroll({
                    height: "auto",
                    position: "right",
                    size: "5px",
                    color: "#9ea5ab",
                    wheelStep: 5,
                    touchScrollStep: 20
                });
            });
        },
        doNothing() {}
    },
    computed: {
        params() {
            console.log(this.currentWebsiteId);
            return { site_id: this.currentWebsiteId };
        },
        ...mapState(["currentWebsiteId"])
    },
    mounted() {
        this.init();
    }
};
</script>

<style lang="scss" scoped>
.logo {
    margin: rem-calc(24) auto;
    margin-top: rem-calc(24);

    img#side-main-logo {
        height: rem-calc(38);
    }
}
</style>